import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const LaneAliasService = {
    create: async (form) => axios.post(API_KEEPER + "/general/lane_alias/create", form).then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/general/lane_alias/" + id).then(({data}) => data).catch((err) => { throw err }),

    edit: async (form) => axios.post(API_KEEPER + "/general/lane_alias/update", form).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/general/lane_alias/delete/" + id).catch((err) => { throw err }),

    lanes: async () => axios.get(API_KEEPER + "/general/lane_alias/lanes").then(({data}) => data).catch((err) => { throw err }),

    adrLanes: async () => axios.get(API_KEEPER + "/general/lane_alias/adr/lanes").then(({data}) => data).catch((err) => { throw err }),

    list: async () => axios.get(API_KEEPER + "/general/lane_alias/list").then(({data}) => data).catch((err) => { throw err })
};

export default LaneAliasService;
